<template>
  <v-container>
    <v-row>
      <v-col>
        <CustomerBase :customer="customer" :users="users" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mb-2">
        <AiApi :customer="customer" />
      </v-col>
    </v-row>
    <v-row>
      <v-tabs v-if="customertabs" v-model="active">
        <v-tab v-for="tab in customertabs" :key="tab.id" @click="visitTab(tab)">
          {{ tab.label }}
        </v-tab>
      </v-tabs>
    </v-row>
    <v-row class="d-flex justify-end pr-3">
      <a :href="route('customer.download.contract-information', {'customer': customer.id, 'prices': 0, 'type': 'pdf'})" target="_blank">
        <v-btn class="primary">
          Download für Kunden
        </v-btn>
      </a>
      <a class="ml-3" :href="route('customer.download.contract-information', {'customer': customer.id, 'prices':1, 'type': 'pdf'})" target="_blank">
        <v-btn class="primary">
          Download
        </v-btn>
      </a>
      <a class="ml-3" :href="route('customer.download.contract-information', {'customer': customer.id, 'prices':1, 'type': 'txt'})" target="_blank">
        <v-btn class="primary">
          Excel Download
        </v-btn>
      </a>
      <a class="ml-3" :href="route('customer.download.all-offers', {'customer': customer.id})" target="_blank">
        <v-btn class="primary">
          Verträge Download
        </v-btn>
      </a>
      <a class="ml-3" :href="route('customer.download.all-offers-no-price', {'customer': customer.id})" target="_blank">
        <v-btn class="primary">
          Verträge Download ohne Preise
        </v-btn>
      </a>
    </v-row>
    <v-row class="pl-3">
      <v-data-table
        :headers="contractOverviewHeader"
        :items="contractOverview"
        :item-class="positionBackground"
        dense
        :items-per-page="-1"
      />
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import CustomerBase from '@/Components/Customer/CustomerBase'
import AiApi from '@/Components/Customer/AiApi'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.customer.name ? this.customer.name : 'Loading...',
      }
   },
   components: {
      CustomerBase,
      AiApi
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      customer: {
         type: Object,
         required: true,
      },
      users: {
         type: Array,
         required: true,
      },
      customertabs: {
         type: Array,
         required: true,
      },
      contractOverview: {
         type: Array,
         required: true,
      }
   },

   data () {
      return {
         dialog: false,
         companyForm: this.$inertia.form({
            customer_number: this.customer.customer_number,
            name: this.customer.name,
            name_short: this.customer.name_short,
            website: this.customer.website,
            created_by: this.customer.created_by,
         }),
         contractOverviewHeader: [
            { text: 'Position', value: 'position' },
            { text: 'Beschreibung', value: 'beschreibung' },
            { text: 'Anzahl', value: 'anz' },
         ],
         active: 2,
      }
   },
   watch: {
      customertabs: function () {
         for (const key in this.customertabs) {
            if (!this.customertabs[key].route) {
               this.activeTab = parseInt(key)
               return
            }
         }
      },
   },
   methods: {
      save () {
         this.companyForm.patch(this.route('company.update', this.customer.id))
      },
      visitTab (tab) {
         if (tab.route) {
            this.$inertia.visit(tab.route)
         }
      },
      positionBackground (pos) {
         return pos.position !== undefined && !String(pos.position).includes('.') ? 'grey' : 'transparent'
      },
   },
}
</script>
